<template>
    <div class="bg-light-grey pb-0 pt-0">
        <Header />
        <section class="user_section module_user_section">
            <div id="page-container" class="page-container bg-light-grey">
                <div class="container-fluid">
                    <div class="container">
                      <router-view></router-view>
                    </div>
                </div>
            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Header from "./header.vue"
import Footer from "./footer.vue"

// import ''
export default {
    name: "userLayout",
    components: {
        Header,
        Footer,
      
    }

}
</script>
<style>
@import './styles.css';
@import './../../assets/css/custom-layout.css';
</style>
